import { get } from "lodash";
import { Helpers } from "../../utils/helper";
import { Occupier } from "./Occupier.model";

export class HoldingOccupier extends Occupier{
  id          : string; //this will be used for animation accordion when remove 
  type        : "existing" | "new";
  existing_type?: "owner" | "occupier" | "additional" | "";
  is_proposed : boolean;
  original_uinfin : string | undefined;
  constructor(initial?:any){
    super(initial);
    this.id = get(initial,'id', Helpers.generateAlphaNumericID());
    this.type = get(initial,'type', 'new');
    this.is_proposed = get(initial,'is_proposed', undefined);
    this.original_uinfin = get(initial, 'original_uinfin', undefined);
    this.existing_type = get(initial, 'existing_type', "");
  }
}
